// src/api/chatWidget.js
import { http } from '@/api/base';

/**
 * 生成或获取聊天窗口配置
 */
export function generateChatConfig(data, tenantId,kbWorkspaceSlug, username) {
    console.log(data, username)
  return http.post('/aics/chat-widget/generate-config',
               data,
       {
        headers: { 'Content-Type': 'application/json',
                    'X-tenant-id': tenantId, // 添加企业ID头
                    'X-kbWorkspace-slug': kbWorkspaceSlug,  // 添加工作区头
                    'X-User-Name': username   // 添加用户头
        
                 
         }

            });
}

/**
 * 根据UUID获取配置
 */
export function getChatConfig(uuid) {
  return http.get(`/aics/chat-widget/config/${uuid}`);
}

/**
 * 获取租户的所有配置
 */
export function getTenantChatConfigs(tenantId) {
  return http.get(`/aics/chat-widget/configs/${tenantId}`);
}